<template>
  <div id="app">
    <transition
      @after-enter="afterEnter"
      :name="animType">
      <router-view/>
    </transition>
    <div class="add-bottom-view"></div>
    <app-nav-bottom v-if="displayBottomNav"></app-nav-bottom>
  </div>
</template>


<script>
import NavBottom from '@/components/NavBottom.vue';

export default {
  components: {
    'app-nav-bottom': NavBottom,
  },
  data() {
    return {
      animType: 'main-nav',
      displayBottomNav: false,
    };
  },
  created() {
    if (this.$route.name !== 'login') {
      this.displayBottomNav = true;
    }
  },
  watch: {
    $route(to, from) {
      if (!['timesheet', 'survey-form', 'settings'].includes(from.name)) {
        this.animType = 'back-anim';
      } else if (['timesheet', 'survey-form', 'settings'].includes(to.name)) {
        this.animType = 'main-nav';
      } else {
        this.animType = 'router-anim';
      }
      if (to.name !== 'login') {
        this.displayBottomNav = true;
      } else {
        this.displayBottomNav = false;
      }
    },
  },
  methods: {
    afterEnter() {
      this.$store.dispatch('changeTransitionWindow');
    },
  },
};
</script>

<style>
:root {
  --login-main-bg-color: rgb(70, 75, 96, 0.3);
  --login-main-color: rgb(70, 75, 96);
}

body {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.add-bottom-view {
  height: 14vh;
}

/* ANIMATION ROUTER TRANSITION */


/* Switch between main views */

.main-nav-enter-active {
  animation: zoomout 0.2s;
  animation-delay: .2s;
  opacity: 0;
}
.main-nav-leave-active {
  animation: zoomin 0.2s;
}

@keyframes zoomin {
  from {
    transform: translateZ(0);
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: translateZ(-100);
    opacity: 0;
    transform: scale(0.9);
  }
}
@keyframes zoomout {
  from {
    transform: translateZ(100);
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    transform: translateZ(0);
    opacity: 1;
    transform: scale(1);
  }
}

/* Switch between relational view */
.router-anim-enter-active {
  animation: coming 0.5s;
  animation-delay: .5s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 0.5s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Back between relational view */
.back-anim-enter-active {
  animation: backfrom 0.5s;
  animation-delay: .5s;
}
.back-anim-leave-active {
  animation: backto 0.5s;
}

@keyframes backfrom {
  from {
    transform: translateX(-100%);
    /* opacity: 1 */
  }
  to {
    transform: translateX(0);
    /* opacity: 0; */
  }
}
@keyframes backto {
  from {
    transform: translateX(0);
    /* opacity: 0; */
  }
  to {
    transform: translateX(100%);
    /* opacity: 1; */
  }
}

</style>
